import { updateUrl } from '../../lib/url';
import getPanoramaData from '../../lib/mapService/getPanoramaData';
import {
  setDepthInfo,
  setPanoramaId,
  setProgress,
} from '../panorama';

const onProgress = (dispatch) => (progress) => dispatch(setProgress(progress));

export default (
    panoramaId,
    isUpdateUrl = true,
) => async (dispatch, getState) => {
  try {
    const data = await getPanoramaData(panoramaId, onProgress(dispatch));
    const {
      canvas,
      links,
      tiles,
    } = data;
    const latestPanoramaId = data.panoramaId || panoramaId;

    dispatch(setDepthInfo({ canvas, links, tiles }));
    dispatch(setPanoramaId(latestPanoramaId, false));
  } catch (e) {
    dispatch(setPanoramaId('', false));
  }

  if (isUpdateUrl) {
    updateUrl(getState());
  }
};
